module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('ui-title', {
    attrs: {
      "icon": "account_circle"
    }
  }, [_vm._v("Not found")]), _vm._v(" "), _c('p', [_vm._v("Ops, parece que essa página não existe!")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Ir para página inicial")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74b0c7a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PageNotFound.vue
// module id = 276
// module chunks = 2